import { render, staticRenderFns } from "./GroupStickyDemo.vue?vue&type=template&id=f020cc9c&scoped=true"
import script from "./GroupStickyDemo.vue?vue&type=script&lang=js"
export * from "./GroupStickyDemo.vue?vue&type=script&lang=js"
import style0 from "./GroupStickyDemo.vue?vue&type=style&index=0&id=f020cc9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f020cc9c",
  null
  
)

export default component.exports